import { 
  useState, 
  useMemo 
}                       from 'react';
import { connect }      from 'react-redux';
import { Dispatch }     from "redux";
import { ActionTypes }  from 'actions/types';
import { reducerType }  from 'reducer';
import Menu             from './Menu';
import Modal            from './Modal';
import { makeStyles }   from 'makeStyles';
import { objType }      from 'types';
import { sizeStateType } from 'reducer/types';

const videoUrl = 'https://yisumatica-screen-recordings.s3.us-east-2.amazonaws.com/'


const useStyles = makeStyles()((Theme) => ({    
    root: {
      position:        'fixed',
      top:             0,
      left:            0,
      width:           '100%',
      height:          '100%',
      backgroundColor: '#00000044',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
    },
    container: {
      width:           '90vw',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      backgroundColor: '#FFF',
      borderRadius:    '0.2em',
      overflow:        'hidden',
      boxShadow:       '3px 3px 3px rgba(0,0,0,0.05)'
    },
    title: {
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      height:          60,
      minHeight:       60,
      width:           '100%',
      fontSize:        19,
      fontWeight:      'bold',
      borderBottom:    '1px solid #DDD',
      borderRight:     '1px solid #DDD',
  },   
    videoContainer: {
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'top',
      flexFlow:        'column',
      width:           '100%',
      height:          '100%'
    },
    video: {
    // padding:      10,
      background:   '#FFF',
      //border:       '1px solid #CCC',
      borderRadius: '0.4em',
   //   boxShadow:    '5px 5px 9px rgba(0,0,0,0.5)',
    },
   
}))

type UserVideoPlayerProps = {
  sizeState:  sizeStateType;
  userVideos: objType[];
  lang:       string;
}

const UserVideoPlayer: React.FC<UserVideoPlayerProps> = ({
  sizeState,
  userVideos,
  lang
}) => {
  
  const { classes } = useStyles();
  //`some_user_id_string`
  const [selectedVideo, setSelectedVideo] = useState(userVideos[0])
  const [showModal, setShowModal]         = useState(false)
  const [modalVariant, setModalVariant]   = useState('')

  const [containerStyle] = useMemo(() => {
    return[
      {
        height: sizeState.size[1] * 0.9
      }
    ]
  },[sizeState])
  
  return (
    <div className = { classes.root }>
      <div 
          className = { classes.container }
          style     = { containerStyle }
      >
          <div className = { classes.videoContainer }>
              <div className = { classes.title }>
                 { selectedVideo.title }
              </div>
              <video 
                className = { classes.video }
                height    = '100%'
                width     = '95%'
                src       = { `${ videoUrl }${ selectedVideo.video_id }` } 
             //   autoPlay
                controls
              /> 
          </div>
          <Menu 
            height           = { containerStyle.height }
            selectedVideo    = { selectedVideo }
            setSelectedVideo = { setSelectedVideo }
            setShowModal     = { setShowModal }
            setModalVariant  = { setModalVariant }
          />
          <Modal 
            selectedVideo = { selectedVideo }
            showModal     = { showModal }
            variant       = { modalVariant }
            lang          = { lang }
            setShowModal  = { setShowModal }
          />
      </div>
    </div>
  );
}



const mapStateToProps = (reducer: reducerType) => {
  return {
    lang:       reducer.components.lang,
    userVideos: reducer.content.userVideos,
    sizeState:  reducer.size
}};


const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
 // setComponentsState: (payload: componentsStateType) => dispatch(SET_COMPONENTS_STATE(payload))
});



export default connect(mapStateToProps, mapDispatchToProps)(UserVideoPlayer);







